<template>
  <qx-card-form title="企业规模">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="140px"
    >
      <el-input
        class="inputBox"
        slot="annualTurnover"
        slot-scope="prop"
        placeholder="请输入"
        v-model="prop.form.annualTurnover"
      >
        <span slot="suffix" class="inputSlotText">万元</span>
      </el-input>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '员工数',
            value: 'staffNumber',
            type: 'input',
          },
          {
            label: '年营业额',
            value: 'annualTurnover',
            slot: true,
          },
        ],
        rules: {
          staffNumber: [ // 员工数
            { required: true, message: '请输入员工数', trigger: 'blur' },
          ],
          annualTurnover: [ // 年营业额
            { required: true, message: '请输入年营业额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        return {
          'businessState.staffNumber': formData.staffNumber,
          'businessState.annualTurnover': formData.annualTurnover,
        };
      }
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data = {}) {
      if (data.tenantInfo) {
        data = data.tenantInfo.businessState;
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
